import React from 'react';
import { OnboardingWizard } from '@/components/onboarding/OnboardingWizard';

const Onboarding: React.FC = () => {
  return <OnboardingWizard />;
};

export default Onboarding;